import { type Client, createClient } from 'graphql-ws'

import { env } from '@/env'

import { getAccessToken } from './graphqlAuth'

/**
 * Derives the WebSocket URL from the HTTP GraphQL URL.
 * Converts http(s):// to ws(s)://
 */
function getWebSocketUrl(httpUrl: string): string {
  return httpUrl.replace(/^http/, 'ws')
}

export const GRAPHQL_WS_ENDPOINT = getWebSocketUrl(env.VITE_GRAPHQL_URL)

let subscriptionClient: Client | null = null

export function getSubscriptionClient(): Client {
  if (!subscriptionClient) {
    subscriptionClient = createClient({
      url: GRAPHQL_WS_ENDPOINT,
      connectionParams: () => {
        const token = getAccessToken()
        if (token) {
          return { Authorization: `Bearer ${token}` }
        }
        return {}
      },
      shouldRetry: () => true,
      retryAttempts: 5,
      retryWait: (retryCount) =>
        new Promise((resolve) =>
          setTimeout(resolve, Math.min(1000 * 2 ** retryCount, 30000)),
        ),
    })
  }
  return subscriptionClient
}

export function disposeSubscriptionClient(): void {
  if (subscriptionClient) {
    void subscriptionClient.dispose()
    subscriptionClient = null
  }
}

// Dedicated client for position stream — the server does not support
// multiplexing, so this must be a separate WS connection.
let positionStreamClient: Client | null = null

export function getPositionStreamClient(): Client {
  if (!positionStreamClient) {
    positionStreamClient = createClient({
      url: GRAPHQL_WS_ENDPOINT,
      connectionParams: () => {
        const token = getAccessToken()
        if (token) {
          return { Authorization: `Bearer ${token}` }
        }
        return {}
      },
      shouldRetry: () => true,
      retryAttempts: 5,
      retryWait: (retryCount) =>
        new Promise((resolve) =>
          setTimeout(resolve, Math.min(1000 * 2 ** retryCount, 30000)),
        ),
    })
  }
  return positionStreamClient
}

export function disposePositionStreamClient(): void {
  if (positionStreamClient) {
    void positionStreamClient.dispose()
    positionStreamClient = null
  }
}
